<template lang="pug">
  .searchpage
    .content
      form.searchform(@submit.prevent="")
        input.searchbox(placeholder="Type keyword(s)" type="text"
          @input="onInput($event.target.value)" @keyup.esc="$emit('esc')" v-model="searchValue")
      .searchresults(v-if="results")
        .results(v-if="results.content.length > 0")
          SearchResult(v-for="r in results.content" :type="r.type" :entity="r.data" :key="r.data.id" @nav="$emit('esc')")
        p.noresults(v-else)
          <strong>No results.</strong> Try entering the name of a {{supportedEntityTypes}}.
        .records Showing {{numberOfElements}} of total {{totalElements}} items
      p(v-if="!searchValue")
        SearchSupport

</template>

<script>
import debounce from 'debounce'
import EntitySearch from '@/service/apis/EntitySearch'
import SearchResult from './SearchResult'
import SearchSupport from './SearchSupport'

export default {
  name: 'Search',
  created() {
    this.onInput = debounce(this.onInput, 200);
    this.fetchSupportedEntites()
  },
  mounted() {
    this.$el.querySelectorAll('input.searchbox')[0].focus()
  },
  data: () => ({
    results: null,
    numberOfElements: null,
    totalElements: null,
    supportedEntityTypes: null,
    error: null,
    searchValue: ''
  }),
  methods: {
    onInput(val) {
      this.error = null;
      if (val) {
        EntitySearch.freeTextSearch(val)
          .then((resp) => {
            this.results = resp.data;
            this.numberOfElements = resp.data.numberOfElements
            this.totalElements = resp.data.totalElements
          })
          .catch((e) => {
            this.$emit('error', e)
          });
      } else {
        this.results = null;
      }
    },
    fetchSupportedEntites() {
      EntitySearch.listSearchableEntityTypes()
        .then((resp) => {
          this.supportedEntityTypes = resp.data.join(', ')
        })
    }
  },
  components: {
    SearchResult,
    SearchSupport
  },
  computed: {
    noresults() {
      return this.results.totalElements === 0;
    }
  }
}
</script>

<style lang="scss">
@import '~kezzler-app-design/src/style/variables';

.records {
  text-align: center;
}

.searchpage {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: $white;
  text-align: center;
  padding: 95px 20px 20px 20px;
  z-index: 98;
  h3 {
    font-size: 15px;
    margin: 35px 20px 10px 20px;
  }
  .error {
    color: red;
  }
}

.searchbox {
  width: 100%;
  font-size: 22px;
  padding: 12px 15px;
  color: $dark-grey;
  outline: 0;
  border: 2px solid $lighter-grey;
  border-radius: 5px;
  &::-webkit-input-placeholder {
    color: $light-grey;
  }
  &::placeholder {
    color: $light-grey;
  }
}

.results {
  display: table;
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  line-height: 24px;
  white-space: nowrap;
  >a {
    border-top: 1px solid $lighter-grey;
  }
  >a:first-child {
    border: none;
  }
  a p,
  a strong {
    display: block;
    width: 500px;
    max-width: 100%;
    height: 24px;
    overflow: hidden;
    margin: 0;
    font-size: 15px;
    line-height: 24px;
    text-overflow: ellipsis;
  }
  a strong {
    font-size: 16px;
    font-weight: 600;
    color: $blue;
  }
  span {
    display: block;
    overflow: hidden;
    width: 140px;
    height: 24px;
    text-overflow: ellipsis;
    text-align: right;
  }
  a {
    display: table-row;
    color: $dark-grey;
    &:hover {
      color: $dark-grey;
    }
    &:hover strong {
      color: $pink;
    }
    div {
      display: table-cell;
      padding: 15px 20px 20px 20px;
      vertical-align: top;
      &:nth-child(1) {
        padding-left: 54px;
      }
    }
  }
}

.res-order div:nth-child(1) {
  background: $white url(~kezzler-app-design/src/assets/icons/order.svg) 0px 7px no-repeat;
  background-size: 44px 44px;
}

.res-section div:nth-child(1) {
  background: $white url(~kezzler-app-design/src/assets/icons/section.svg) 0px 7px no-repeat;
  background-size: 44px 44px;
}

.res-roll div:nth-child(1) {
  background: $white url(~kezzler-app-design/src/assets/icons/roll.svg) 0px 7px no-repeat;
  background-size: 44px 44px;
}

.res-code div:nth-child(1) {
  background: $white url(~kezzler-app-design/src/assets/icons/code.svg) 0px 7px no-repeat;
  background-size: 44px 44px;
}

.res-location div:nth-child(1) {
  background: $white url(~kezzler-app-design/src/assets/icons/location.svg) 0px 7px no-repeat;
  background-size: 44px 44px;
}

.res-audit-log div:nth-child(1) {
  background: $white url(~kezzler-app-design/src/assets/icons/audit-log.svg) 0px 7px no-repeat;
  background-size: 44px 44px;
}

@media (min-width: 1024px) {
  .searchform {
    padding-bottom: 25px;
  }
  .res-code div:last-child,
  .res-location div:last-child {
    padding-top: 44px;
  }
  .searchresults a {
    p,
    strong {
      width: 300px;
    }
  }
}

@media (max-width: 1023px) {
  .searchbox {
    font-size: 20px;
    padding: 7px 0;
    border-bottom-width: 2px;
    &::-webkit-input-placeholder {
      color: $grey;
    }
    &::placeholder {
      color: $grey;
    }
  }

  .searchresults {
    a {
      border-top: 1px solid $lighter-grey;
    }
    .results {
      p,
      strong {
        width: 300px;
      }
    }
  }
}

@media (max-width: 767px) {
  .searchresults {
    display: block;
    p,
    strong,
    span {
      width: 100%;
      height: auto;
    }
    .results {
      display: block;
      white-space: normal;
    }
    a {
      display: block;
      padding-bottom: 15px;
      &:active strong {
        color: $pink;
      }
      >div {
        display: block;
        +div {
          width: 100%;
          text-align: left !important;
          padding: 0 10px 0 74px;
          font-size: 13px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/search/Search.vue